import { render, staticRenderFns } from "./TableImg.vue?vue&type=template&id=b46c96f2&scoped=true"
import script from "./TableImg.vue?vue&type=script&lang=js"
export * from "./TableImg.vue?vue&type=script&lang=js"
import style0 from "./TableImg.vue?vue&type=style&index=0&id=b46c96f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46c96f2",
  null
  
)

export default component.exports